import { render } from "./EditableItemText.vue?vue&type=template&id=3c495f2c&scoped=true&ts=true"
import script from "./EditableItemText.vue?vue&type=script&lang=ts"
export * from "./EditableItemText.vue?vue&type=script&lang=ts"

import "./EditableItemText.vue?vue&type=style&index=0&id=3c495f2c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c495f2c"]])

export default __exports__